import { FirestoreOrderSummary, OrderSummary } from '@lib/types';

export function fromFirestoreOrderSummaryToOrderSummary(
  firestoreOrder: FirestoreOrderSummary,
): OrderSummary {
  return {
    ...firestoreOrder,
    seenAt: firestoreOrder.createdAt.toDate(),
    createdAt: firestoreOrder.createdAt.toDate(),
  };
}
